<div class="sb-overlay">
  <h3>Share</h3>
  <div *ngIf="isBtnCopy" #shareButton="shareButton" shareButton="copy" class="sb-copy-url">
    <span>{{ shareButton?.url }}</span>
  </div>

  <share-buttons [include]="options?.include"
                 [exclude]="options?.exclude"
                 [theme]="options?.theme"
                 [url]="options?.url"
                 [title]="options?.title"
                 [description]="options?.description"
                 [image]="options?.image"
                 [tags]="options?.tags"
                 [autoSetMeta]="options?.autoSetMeta"
                 [show]="options?.show"
                 [showIcon]="options?.showIcon"
                 [showText]="options?.showText"
                 [size]="options?.size"
                 (opened)="options?.opened?.emit($event)"
                 (closed)="options?.closed?.emit($event)"
                 [disabled]="options?.disabled">
  </share-buttons>

  <div class="sb-close-overlay" (click)="options.closeClick.emit()">
    <fa-icon [icon]="options.closeIcon"></fa-icon>
  </div>

</div>
